const mEditionProductPagesOfGratefulness = {
  mEditionProductPagesOfGratefulness: {
    alerts: {
      createProductoPaginaIdroopActivarEdicion: {
        error: 'Un error ha ocurrido. Vuelve a intentarlo en un momento.'
      },

      updateProductoPaginaIdroopPublicar: {
        activationSuccess: 'La página de agradecimiento fue publicada como primaria exitosamente.',
        deactivationSuccess: 'La página de agradecimiento fue desactivada como primaria exitosamente.',
        error: 'Un error ha ocurrido. Vuelve a intentarlo en un momento.'
      }
    },

    externalSite: 'sitio externo',

    quote: {
      firstTextProductSalesLetters: 'Aún no tienes Paginas de agradecimiento asociadas a este producto. Agrega tu Pagina de agradecimiento haciendo',
      secondTextProductSalesLetters: 'click aquí.'
    },

    table: {
      thDelete: 'Eliminar',
      thEdit: 'Editar',
      thName: 'Nombre',
      thPrimary: 'Primaria',
      thWatch: 'Ver'
    },

    tooltip: {
      delete: 'Eliminar Página',
      edit: 'Editar Página',
      watch: 'Ver Página'
    }
  }
}

export default mEditionProductPagesOfGratefulness
